import {
    asyncListWithSkipTakeCreate,
    cachedValueCreateWithParamsV2,
    Evaluable,
    evaluateWhenFunction,
    hashFunctionCreate,
    stringReplaceEmptyOrWhiteSpaceValue,
    valueConvertWhenNotNullable
} from '@wix/devzai-utils-common';
import type {DoppeDtoBookingService, DoppeDtoBookingServiceType} from '../../../client-server-common/types/doppe-dto-booking-service';
import type {IDoppeViewerApi} from '../../../client-server-common/api/doppe-viewer-api';

export function doppeViewerAsyncListFactoryServices(
    viewerApiClientGetter: Evaluable<() => IDoppeViewerApi>
) {
    return cachedValueCreateWithParamsV2({
        paramsHashFunction: hashFunctionCreate<doppeViewerAsyncListFactoryServices.Params>({
            search: hashFunctionCreate(),
            serviceType: hashFunctionCreate(),
        }),
        paramsNormalizationFunction: params => ({
            ...params,
            search: valueConvertWhenNotNullable(params.search, s =>
                stringReplaceEmptyOrWhiteSpaceValue(s, undefined)
            )
        }),
        valueFunction: (params) => {
            const viewerApiClient = evaluateWhenFunction(viewerApiClientGetter);

            return asyncListWithSkipTakeCreate<DoppeDtoBookingService>({
                fetchFunction: async (skip, take) => {
                    return viewerApiClient.getBookingServices({
                        skip: skip,
                        take: take,
                        search: params.search,
                        serviceType: params.serviceType,
                    });
                },
                defaultTake: 30,
            });
        }
    });
}

export namespace doppeViewerAsyncListFactoryServices {
    export interface Params {
        search?: string;
        serviceType?: DoppeDtoBookingServiceType;
    }
}

export function doppeViewerAsyncListFactoryServicesByCategory(
    viewerApiClientGetter: Evaluable<() => IDoppeViewerApi>
) {
    return cachedValueCreateWithParamsV2({
        paramsHashFunction: hashFunctionCreate<doppeViewerAsyncListFactoryServicesByCategory.Params>({
            categorySlug: hashFunctionCreate(),
        }),
        valueFunction: (params) => {
            const viewerApiClient = evaluateWhenFunction(viewerApiClientGetter);

            return asyncListWithSkipTakeCreate<DoppeDtoBookingService>({
                fetchFunction: async (skip, take) => {
                    return viewerApiClient.getBookingServices({
                        skip: skip,
                        take: take,
                        categorySlug: params.categorySlug,
                    });
                },
                defaultTake: 30,
            });
        }
    });
}

export namespace doppeViewerAsyncListFactoryServicesByCategory {
    export interface Params {
        categorySlug: string;
    }
}
